import { API_ENV } from '@/appConfig';

const sitePublicEndpoints: Record<typeof API_ENV, string> = {
	local: 'http://localhost:3000',
	dev: 'https://dev-tokamap-com.staging.stonecode.io',
	demo: 'https://demo-tokamap-com.staging.stonecode.io',
	preprod: 'https://preproduction-tokamap-com.staging.stonecode.io',
	prod: 'https://tokamap.com',
};

export default function getSitePublicUrl() {
	return sitePublicEndpoints[API_ENV];
}

export const getSitePublicContactUrl = () => `${getSitePublicUrl()}/contact`;
export const getSitePublicPrivacyPolicyUrl = () => `${getSitePublicUrl()}/politique-de-confidentialité`;
